import {AUTO_REDIRECTED_TO_BETTER_LANGUAGE} from '../serve/consts';
import {get, set} from '../serve/localStorage';

type RedirectedToBetterLanguageState = {
  fromLang: string;
  toLang: string;
  decidedLanguagesHash: string;
};

export function setAutoRedirectedToBetterLanguage(
  state: RedirectedToBetterLanguageState
): void {
  set(AUTO_REDIRECTED_TO_BETTER_LANGUAGE, state);
}

export function getAutoRedirectedToBetterLanguage() {
  return get<RedirectedToBetterLanguageState>(
    AUTO_REDIRECTED_TO_BETTER_LANGUAGE
  );
}

export function getDecidedLanguagesHash(languages: readonly string[]) {
  return languages.join();
}
